import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { fetchSchoolMissions } from '../../services2/schoolMissions.service';
import { useSetting } from '../../util/useSetting';
import VerticalDragableList from '../teacher/components/VerticalDragableList';
import SliderPage from '../teacher/components/SliderPage';
import SettingPopup from '../teacher/components/SettingPopup';
const NUMBER = 1000

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const { fontSize } = useSetting();

    const [searchParams] = useSearchParams();
    const session = searchParams.get('session') || null;

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {
            _id: id
        }
        let result = await fetchSchoolMissions(props.token.token, filter, { limit: 1, skip: 0 });
        if (result.result) {
            let d = result.result?.[0] || null;
            if (!d.pages) d.pages = d.mission?.pages || [];
            if (!d.pages2) d.pages2 = JSON.parse(JSON.stringify(d.mission?.pages || []))
            if (!d.questions) d.questions = JSON.parse(JSON.stringify([...d.mission?.pages[0]?.questions || [], ...d.mission?.pages[1]?.questions || []]));
            setdata(d)
        } else {
            alert('Fetch data error')
        }
        setisLoading(false)
    }



    useEffect(() => {
        fetchData()
    }, [id])

    const [selectedPage, setSelectedPage] = useState('電子書 1')

    const handleUpdateData = (newData) => {
        setdata(newData)
    }

    const [showClassSelectionPopup, setShowClassSelectionPopup] = useState(false)
    useEffect(() => {
        if (selectedPage === '上課互動區 1' || selectedPage === '上課互動區 2') {
            setShowClassSelectionPopup(true)
        } else {
            setShowClassSelectionPopup(false)
        }
    }, [selectedPage])

    const [articleIndex, setArticleIndex] = useState(0);
    const [electronicBookArticleIndex, setElectronicBookArticleIndex] = useState(0);
    const [isSettingMenuVisible, setIsSettingMenuVisible] = useState(false);


    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-row flex' style={{ fontSize }}>

            {/*menu bar*/}
            <div className='w-[330px] bg-[#F5F5F5] overflow-auto h-[100%] flex flex-col' style={{ backgroundImage: `url(/secondary/bg8.png)`, backgroundSize: 'cover', backgroundPosition: 'end' }}>
                <div className='relative w-full flex flex-col p-[16px] font-bold overflow-auto bg-[#F8FAFB]' style={{ minHeight: 186, backgroundImage: `url(${data?.mission?.photo})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='absolute bottom-0 left-0 right-0 h-[50%] z-[1]' style={{ background: 'linear-gradient(to top, #EDF5F8, rgba(0,0,0,0))' }} />
                    <div>
                        <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }} onClick={() => setIsSettingMenuVisible(!isSettingMenuVisible)}>
                            <img src='/secondary/setting.png' alt='設定' />
                            設定
                        </button>
                    </div>
                    <div className='flex-1 flex flex-col items-start justify-end z-[2] font-[900]' style={{ fontSize: fontSize + 4 }}>{data?.mission?.name}</div>
                </div>
                <div className='p-[16px] flex flex-col'>
                    {session === '單元習題' && <div className='flex-1 flex flex-col items-start justify-end z-[2] font-[900]' style={{ fontSize: fontSize + 4 }}>單元習題</div>}
                    {session === '單元習題' && <div className='flex-1 flex flex-col items-start justify-end z-[2] font-[900] my-[24px]' style={{ fontSize: fontSize, color: '#003A57' }}>電子書</div>}
                    {(session === '互文閱讀一' || session === '互文閱讀二') && <div className='flex-1 flex flex-col items-start justify-end z-[2] font-[900]' style={{ fontSize: fontSize, color: '#003A57' }}>{session}</div>}
                    {(session === '互文閱讀一' || session === '互文閱讀二') && <div className='flex-1 flex flex-col items-start justify-end z-[2] font-[900]' style={{ fontSize: fontSize }}>
                        {data?.mission?.pages?.[session === '互文閱讀一' ? 0 : 1]?.core_questions?.map((question, index) => (
                            <div key={index} className='mb-[16px] flex flex-row text-black font-bold noto-san-hk gap-[6px] text-left mt-[24px]' style={{ fontSize: fontSize + 4 }}>
                                {question.question}
                            </div>
                        ))}
                        <button className='text-white px-[36px] py-[4px] rounded-[8px] w-full' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}>
                            回答核心問題
                        </button>
                        <div className='flex-1 flex flex-col items-start justify-end mt-[16px] font-[900]' style={{ fontSize: fontSize, color: '#003A57' }}>電子書</div>
                    </div>}

                    {(session === '互文閱讀一' || session === '互文閱讀二') && data?.mission?.pages?.[session === '互文閱讀一' ? 0 : 1]?.articles?.map((article, index) => (
                        <button key={index} className='mb-[16px] flex flex-row font-bold noto-san-hk gap-[6px] underline text-left rounded-[8px] p-[6px]'
                            style={{ border: electronicBookArticleIndex === index ? '1px solid white' : 'transparent',color: electronicBookArticleIndex === index ? '#003A57' : 'black' }}
                            onClick={() => {
                                setElectronicBookArticleIndex(index);
                            }}>
                            <div className='mt-[8px]'>
                                <div className='w-[10px] h-[10px] rounded-full' style={{ background: electronicBookArticleIndex === index ? '#003A57' : 'black' }} />
                            </div>
                            {article.name}
                        </button>
                    ))}

                    {session === '單元習題' && data?.mission?.pages?.[0]?.articles?.map((article, index) => (
                        <button key={index} className='mb-[16px] flex flex-row text-black font-bold noto-san-hk gap-[6px] underline text-left rounded-[8px] p-[6px]' 
                        style={{ border: articleIndex === index ? '1px solid white' : 'transparent',color: articleIndex === index ? '#003A57' : 'black' }}
                            
                        onClick={() => {
                            setArticleIndex(index);
                        }}>
                            <div className='mt-[8px]'>
                                <div className='w-[10px] h-[10px] rounded-full' style={{ background: articleIndex === index ? '#003A57' : 'black' }} />
                            </div>
                            {article.name}
                        </button>
                    ))}
                    {session === '單元習題' && data?.mission?.pages?.[1]?.articles?.map((article, index) => (
                        <button key={index} className='mb-[16px] flex flex-row text-black font-bold noto-san-hk gap-[6px] underline text-left rounded-[8px] p-[6px]' 
                        style={{ border: articleIndex === index+NUMBER ? '1px solid white' : 'transparent',color: articleIndex === index+NUMBER ? '#003A57' : 'black' }}
                        onClick={() => {
                            setArticleIndex(index+NUMBER);
                        }}>
                            <div className='mt-[8px]'>
                                <div className='w-[10px] h-[10px] rounded-full' style={{ background: articleIndex === index+NUMBER ? '#003A57' : 'black' }}  />
                            </div>
                            {article.name}
                        </button>
                    ))}
                </div>



                <div className='flex-1 flex-col flex justify-end p-[16px] items-center'>
                    <button onClick={() => { navigate('/platform2/missions') }} className='w-[90%] cursor-pointer flex flex-row justify-center items-center rounded-[16px] p-[16px] gap-[20px] mt-[16px]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                        <img src='/secondary/menu/logout.png' alt='' style={{ height: '36px', objectFit: 'contain' }} />
                        <div className='font-[900] text-center' style={{ color: 'white' }}>返回</div>
                    </button>
                </div>

            </div>

            <div className='flex flex-col flex-1 h-full noto-san-hk font-[400]'>
                {data && <SliderPage leftComponent={
                    session === '互文閱讀一' ?
                        <ElectronicBook selectedPage={selectedPage} index={0} data={data} setdata={handleUpdateData} articleIndex={electronicBookArticleIndex} setArticleIndex={setElectronicBookArticleIndex} />
                        : session === '互文閱讀二' ?
                            <ElectronicBook selectedPage={selectedPage} index={1} data={data} setdata={handleUpdateData} articleIndex={electronicBookArticleIndex} setArticleIndex={setElectronicBookArticleIndex} />
                            : session === '單元習題' ?
                                <PracticeZoneBook articleIndex={articleIndex} setArticleIndex={setArticleIndex} selectedPage={selectedPage} data={data} setdata={handleUpdateData} />
                                : null
                }
                    rightComponent={
                        session === '互文閱讀一' ?
                            <WorkSheet index={0} data={data} setdata={handleUpdateData} />
                            : session === '互文閱讀二' ?
                                <WorkSheet index={1} data={data} setdata={handleUpdateData} />
                                : session === '單元習題' ?
                                    <PracticeZoneExercise selectedPage={selectedPage} data={data} setdata={handleUpdateData} />

                                    : null
                    } />}
            </div>

            {isLoading && <LoadingPage />}
            {isSettingMenuVisible && (
                <SettingPopup onClose={() => {navigate('/platform2/missions')}} onReturn={() => setIsSettingMenuVisible(false)} enableReturn={true} />
            )}
        </div>
    );
}

function WorkSheet(props) {
    const { fontSize } = useSetting();
    const getIndex = (index) => {
        //only start count when the question is selected
        let count = 0;
        for (let i = 0; i <= index; i++) {
            if (props.data?.pages?.[props.index]?.questions?.[i]?.selected) {
                count++;
            }
        }
        return count;
    }
    return (
        <div className='flex flex-col w-full h-full font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='flex flex-row items-center justify-start p-[8px]' style={{ background: 'linear-gradient(to right, #63BBD1, #34778C)' }}>
                <button className='rounded-[8px] text-white px-[16px] py-[8px] bg-[#EE8D59]'>工作紙預覽</button>
            </div>
            <div className='flex flex-col w-full gap-[16px] px-[16px] overflow-auto'>
                <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'linear-gradient(to right, #003A57, #108B96)' }}>
                    <div className='text-white p-[16px]' style={{ fontSize: fontSize + 2 }}>核心問題</div>
                    <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                        <div>{props.data?.mission?.pages?.[props.index]?.core_questions?.[0]?.question}</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                        <div className='flex flex-row justify-end'>
                            <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}>
                                儲存
                            </button>
                        </div>
                    </div>
                </div>
                {props.data?.pages?.[props.index]?.questions?.map((question, index) => (
                    question.selected ?
                        <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                            <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {getIndex(index)}</div>
                            <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                                <div>{question?.question}</div>
                                {question.type === '選擇題' ?
                                    <div className='p-[8px] rounded-[8px] flex flex-col'>
                                        {question.options?.map((option, idx) => (
                                            <div key={idx}>
                                                <button className='text-black bg-[#ccc] px-[18px] py-[4px] rounded-[4px] mb-[4px] min-w-[200px]'>
                                                    {option.option}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    :
                                    <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                                }
                                <div className='flex flex-row justify-end'>
                                    <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}>
                                        儲存
                                    </button>
                                </div>
                            </div>
                        </div>
                        : null
                ))}
            </div>
        </div>
    );
}

function PracticeZoneBook(props) {
    const { fontSize } = useSetting();
    const { articleIndex, setArticleIndex } = props;

 
    const [isViewingBook, setisViewingBook] = useState(true);
    const getIndex = (index) => {
        //only start count when the question is selected
        let count = 0;
        for (let i = 0; i <= index; i++) {
            if (props.data?.questions?.[i]?.selected) {
                count++;
            }
        }
        return count;
    }
    return (
        <div className='flex flex-col w-full h-full font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='flex flex-row items-center justify-start p-[8px] h-[50px] gap-[16px] text-white' style={{ background: 'linear-gradient(to right, #63BBD1, #34778C)' }}>
                電子書
            </div>
            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px]'>
                {props.data?.mission?.pages?.[0]?.articles?.map((article, index) => (
                    (props.data?.pages2?.[0]?.articles?.[index]?.selected || true) || props.data?.pages2?.[0]?.articles?.[index]?.sections?.some(section => section?.selected) ?
                        <button
                            className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                            style={articleIndex === index ? { background: 'linear-gradient(to right, #63BBD1, #34778C)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                            onClick={() => setArticleIndex(index)}
                        >
                            篇章{index === 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' : index + 1}
                        </button>
                        : null
                ))}
                {props.data?.mission?.pages?.[1]?.articles?.map((article, index) => (
                    (props.data?.pages2?.[1]?.articles?.[index]?.selected || true) || props.data?.pages2?.[1]?.articles?.[index]?.sections?.some(section => section?.selected) ?
                        <button
                            className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                            style={articleIndex === index + NUMBER ? { background: 'linear-gradient(to right, #63BBD1, #34778C)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                            onClick={() => setArticleIndex(index + NUMBER)}
                        >
                            篇章{index === 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' : index + 1}
                        </button>
                        : null
                ))}
            </div>
            <div className='flex flex-col w-full px-[16px] gap-[16px]'>
                {props.data?.mission?.pages?.[0]?.articles?.[articleIndex]?.sections?.map((section, sectionIndex) =>
                    ((props.data?.pages2?.[0]?.articles?.[articleIndex]?.selected || true) && section.type === 'main') || (props.data?.pages2?.[0]?.articles?.[articleIndex]?.sections?.[sectionIndex]?.selected || true) ?
                        <RenderASection section={section} key={sectionIndex} /> : null
                )}
                {articleIndex >= NUMBER && props.data?.mission?.pages?.[1]?.articles?.[articleIndex - NUMBER]?.sections?.map((section, sectionIndex) =>
                    ((props.data?.pages2?.[1]?.articles?.[articleIndex - NUMBER]?.selected || true) && section.type === 'main') || (props.data?.pages2?.[1]?.articles?.[articleIndex - NUMBER]?.sections?.[sectionIndex]?.selected || true)?
                        <RenderASection section={section} key={sectionIndex} /> : null
                )}
            </div>
        </div>
    );
}
function PracticeZoneExercise(props) {
    const { fontSize } = useSetting();
    const NUMBER = 1000
    const getIndex = (index) => {
        //only start count when the question is selected
        let count = 0;
        for (let i = 0; i <= index; i++) {
            if (props.data?.questions?.[i]?.selected) {
                count++;
            }
        }
        return count;
    }
    return (
        <div className='flex flex-col w-full h-full font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='flex flex-row items-center justify-start p-[8px] h-[50px] gap-[16px] text-white' style={{ background: 'linear-gradient(to right, #63BBD1, #34778C)' }}>
                單元習題工作紙
            </div>
            <div className='flex flex-col w-full gap-[16px] px-[16px] overflow-auto'>
                {props.data?.questions?.map((question, index) => (
                    question.selected ?
                        <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                            <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {getIndex(index)}</div>
                            <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                                <div>{question?.question}</div>
                                {question.type === '選擇題' ?
                                    <div className='p-[8px] rounded-[8px] flex flex-col'>
                                        {question.options?.map((option, idx) => (
                                            <div key={idx}>
                                                <button className='text-black bg-[#ccc] px-[18px] py-[4px] rounded-[4px] mb-[4px] min-w-[200px]'>
                                                    {option.option}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    :
                                    <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                                }
                                <div className='flex flex-row justify-end'>
                                    <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }}>
                                        儲存
                                    </button>
                                </div>
                            </div>
                        </div>
                        : null
                ))}

            </div>
        </div>
    );
}

function ElectronicBook(props) {
    const { fontSize } = useSetting();
    const { articleIndex, setArticleIndex } = props;
    return (
        <div className='flex flex-col w-full h-full font-[700] gap-[16px] overflow-auto' style={{ fontSize }}>
            <div className='flex flex-row items-center justify-between p-[8px]' style={{ background: 'linear-gradient(to right, #63BBD1, #34778C)' }}>
                {props.selectedPage.includes('電子書') ?
                    <button className='rounded-[8px] text-white px-[16px] py-[8px] bg-[#EE8D59]'>電子書預覽</button>
                    : <div className='text-white font-[900]'>電子書</div>
                }
                {props.selectedPage.includes('電子書') ? null :
                    <button onClick={props.onSettingClick} className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                        <div className='rounded-full px-[16px] py-[4px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                            {'顯示設定'}
                        </div>
                    </button>
                }
            </div>
            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px]'>
                {props.data?.mission?.pages?.[props.index]?.articles?.map((article, index) => (
                    (props.data?.pages?.[props.index]?.articles?.[index]?.selected || true) || props.data?.pages?.[props.index]?.articles?.[index]?.sections?.some(section => section?.selected) ?
                        <button
                            className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                            style={articleIndex === index ? { background: 'linear-gradient(to right, #63BBD1, #34778C)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                            onClick={() => setArticleIndex(index)}
                        >
                            篇章{index === 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' : index + 1}
                        </button>
                        : null
                ))}
            </div>
            <div className='flex flex-col w-full px-[16px] gap-[16px]'>
                {props.data?.mission?.pages?.[props.index]?.articles?.[articleIndex]?.sections?.map((section, sectionIndex) =>
                    ((props.data?.pages?.[props.index]?.articles?.[articleIndex]?.selected || true) && section.type === 'main') || (props.data?.pages?.[props.index]?.articles?.[articleIndex]?.sections?.[sectionIndex]?.selected ||true)?
                        <RenderASection section={section} key={sectionIndex} /> : null
                )}
            </div>
        </div>
    );
}


function RenderASection({ section }) {
    const { fontSize } = useSetting();
    return (
        <div className='flex flex-col items-center justify-start gap-[16px] w-full rounded-[8px] py-[16px]' style={section.backgroundImage ? { backgroundImage: `url(${section.backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: section.backgroundColor || 'transparent' } : { backgroundColor: section.backgroundColor || 'transparent' }}>
            {section?.contents?.map((content, contentIndex) => (
                <div key={contentIndex} className='text-black w-full flex items-center justify-center'>
                    {content.type === '圖片' ?
                        <img className='px-[32px]' src={content.url} alt='' />
                        : content.type === '標題' ?
                            <div className='text-black font-bold text-center w-[90%] px-[32px]' style={{ fontSize: fontSize + 4 }}>{content.text}</div>
                            : content.type === '文字' ?
                                <div className='px-[32px] py-[8px] text-justify flex flex-col items-center justify-center font-[400]' dangerouslySetInnerHTML={{ __html: content.text }}></div>
                                : content.type
                    }
                </div>
            ))}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
